/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IERC20LikeV2, IERC20LikeV2Interface } from "../IERC20LikeV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IERC20LikeV2__factory {
  static readonly abi = _abi;
  static createInterface(): IERC20LikeV2Interface {
    return new utils.Interface(_abi) as IERC20LikeV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IERC20LikeV2 {
    return new Contract(address, _abi, signerOrProvider) as IERC20LikeV2;
  }
}
